import {
  getAllGroups,
  getAllResources,
  getAllActions,
  getGroupResourceActionMapping,
  type UpdateGroupParams,
  insertGroup,
  updateGroup,
  type createGroupParams,
  createGroup,
} from "@/api/groupService";
import { CACHE_TIME } from "@/lib/cacheConfig";
import { useQueryInvalidation } from "@/lib/queryInvalidation";
import { queryKeys } from "@/lib/queryKeys";
import { useQuery, useMutation } from "@tanstack/react-query";

export const useGetAllGroups = () => {
  return useQuery({
    queryKey: queryKeys.group.list(),
    queryFn: getAllGroups,
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};

export const useGetAllResources = () => {
  return useQuery({
    queryKey: queryKeys.group.resource(),
    queryFn: getAllResources,
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};

export const useGetAllActions = () => {
  return useQuery({
    queryKey: queryKeys.group.action(),
    queryFn: getAllActions,
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};

export const useGetGroupResourceActionMapping = () => {
  return useQuery({
    queryKey: queryKeys.group.groupResourceActionMapping(),
    queryFn: getGroupResourceActionMapping,
    staleTime: CACHE_TIME.MASTER_DATA,
  });
};

export const useCreateGroup = () => {
  const queryInvalidation = useQueryInvalidation();

  return useMutation({
    mutationKey: queryKeys.group.create(),
    mutationFn: (params: createGroupParams) => createGroup(params),
    onSuccess: () => {
      queryInvalidation.invalidateGroup();
      queryInvalidation.invalidateGroupResourceActionMapping();
    },
  });
};

export const useInsertGroup = () => {
  const queryInvalidation = useQueryInvalidation();
  
  return useMutation({
    mutationKey: queryKeys.group.insert(),
    mutationFn: (params: UpdateGroupParams) => insertGroup(params),
    onSuccess: () => {
      queryInvalidation.invalidateGroup();
      queryInvalidation.invalidateGroupResourceActionMapping();
    },
  });
};

export const useUpdateGroup = () => {
  const queryInvalidation = useQueryInvalidation();
  
  return useMutation({
    mutationKey: queryKeys.group.update(),
    mutationFn: (params: UpdateGroupParams) => updateGroup(params),
    onSuccess: () => {
      queryInvalidation.invalidateGroup();
      queryInvalidation.invalidateGroupResourceActionMapping();
    },
  });
};